import { FC } from 'react';
import { assetsPath } from 'Data/constants';
import styles from './spinner.module.scss';

export const Spinner: FC  = () => (
  <img src={`${assetsPath}/site-media/spinner.gif`} alt="The page is loading" className={styles.loader} />
);
